import useStyleBuilder from "./useStyleBuilder";
import useClassBuilder from "./useClassBuilder";

export default function useComponentStyling(baseClass = "", props = {}, modifiers = [], customClasses = []) {
	return {
		classNames: useClassBuilder(props, baseClass, customClasses, modifiers),
		style: useStyleBuilder(props),
	};
}
